import { ImageHeaderLarge } from '../components/ImageHeaderLarge';
import HeaderContent from '../components/HeaderContent';
import headerImage from 'url:../assets/wedding-party-2.jpg';
import erinLuka from 'url:../assets/engagement.png';
const HomePage = () => {
  const imageUrl = headerImage;

  return (
    <>
      <ImageHeaderLarge headerContent={<HeaderContent />} imageUrl={imageUrl} />
      <article className="block-content block-content-longtext">
        <h2>Join the Quest</h2>
        <p><a href="/weekend-schedule">Check out the full schedule here,</a> including details of the ceremony day.</p>
        <p>We've also created a <a href="/faqs">FAQs page</a> to answer common questions.</p>
        <p>We can't wait to celebrate with you!</p>
        <img src={erinLuka} alt="Erin and Luka" style={{ width: '400px', margin: '0 auto 1rem', borderRadius: '8px' }} />
        <p className="paragraph-display">Erin & Luka x</p>
      </article>
    </>
  );
};

export default HomePage;
